import React from 'react'
import './LoginAdmin.scss'
import { LoginForm } from '../../../components/Admin'

export function LoginAdmin() {
  return (
        <div className="bl_login">   
            <div className='bl_logo'>
                <svg xmlns="http://www.w3.org/2000/svg" width="108.572" height="129.183" viewBox="0 0 108.572 129.183">
                <path d="M10590.929,128.183l-4.93-17.967,4.93-13.48h29.016l-2.157,25.911c-.271,3.25-1.27,5.536-2.415,5.536Zm7.061-48.22a6,6,0,0,1-6-6V50.314h86.992a6,6,0,0,1,6,6V79.963Zm-4.8-48.518,6.293-25.906A7.248,7.248,0,0,1,10606.523,0h72.468l14.376,17.97-14.376,13.475Z" transform="translate(-10585.475 0.5)" fill="#fff" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"/>
                </svg>


            </div>    
            <div className='bl_form'>            
                <LoginForm/>
            </div>
            <div className='bl_copy'>
                <p>Copyright © 2025 - Menupolis®. All rights reserved.</p>
            </div>
        </div>
  )
}
